import { interopDefault } from '~/router/utils'

export const accountEshopRoutes = [
  {
    path: 'eshop/',
    name: '__account_eshop',
    component: () =>
      interopDefault(
        import(
          '~/pages/car/account/eshop/index.vue' /* webpackChunkName: "pages-account-eshop-index.vue" */
        )
      ),
    meta: {
      scrollTopSmooth: true
    },
    redirect: { name: '__account_eshop_overview' },
    children: [
      {
        path: 'onboarding/',
        name: '__account_eshop_onboarding',
        component: () =>
          interopDefault(
            import(
              '~/pages/car/account/eshop/onboarding.vue' /* webpackChunkName: "pages-account-eshop-onboarding.vue" */
            )
          ),
        meta: {
          scrollTopSmooth: true,
          hideTabs: true
        }
      },
      {
        path: 'overview/',
        name: '__account_eshop_overview',
        component: () =>
          interopDefault(
            import(
              '~/pages/car/account/eshop/overview.vue' /* webpackChunkName: "pages-account-eshop-overview.vue" */
            )
          ),
        meta: {
          scrollTopSmooth: true
        }
      },
      {
        path: 'orders/',
        name: '__account_eshop_orders',
        component: () =>
          interopDefault(
            import(
              '~/pages/car/account/orders/list.vue' /* webpackChunkName: "pages-account-orders-list.vue" */
            )
          ),
        meta: {
          scrollTopSmooth: true
        }
      },
      {
        path: 'order/:orderId/',
        name: '__account_eshop_orders_order_details',
        component: () =>
          interopDefault(
            import(
              '~/pages/car/account/orders/order.vue' /* webpackChunkName: "pages-account-orders-order.vue" */
            )
          ),
        meta: {
          scrollTopSmooth: true,
          hideTabs: true
        }
      },
      {
        path: 'products/',
        name: '__account_eshop_products',
        component: () =>
          interopDefault(
            import(
              '~/pages/car/account/eshop/products.vue' /* webpackChunkName: "pages-account-eshop-products.vue" */
            )
          ),
        meta: {
          scrollTopSmooth: true
        }
      },
      {
        path: 'shipping-options/',
        name: '__account_eshop_shipping_options',
        component: () =>
          interopDefault(
            import(
              '~/pages/car/account/eshop/shipping-option/list.vue' /* webpackChunkName: "pages-account-eshop-shipping-option-list.vue" */
            )
          ),
        meta: {
          scrollTopSmooth: true
        }
      },
      {
        path: 'shipping-options/:optionId/edit/',
        name: '__account_eshop_shipping_options_edit',
        component: () =>
          interopDefault(
            import(
              '~/pages/car/account/eshop/shipping-option/edit.vue' /* webpackChunkName: "pages-account-eshop-shipping-option-edit.vue" */
            )
          ),
        meta: {
          scrollTopSmooth: true,
          hideTabs: true,
          noBackTopMenu: true
        }
      },
      {
        path: 'shipping-options/new/',
        name: '__account_eshop_shipping_options_new',
        component: () =>
          interopDefault(
            import(
              '~/pages/car/account/eshop/shipping-option/new.vue' /* webpackChunkName: "pages-account-eshop-shipping-option-new.vue" */
            )
          ),
        meta: {
          scrollTopSmooth: true,
          hideTabs: true,
          noBackTopMenu: true
        }
      },
      {
        path: 'transactions/',
        name: '__account_eshop_transactions',
        component: () =>
          interopDefault(
            import(
              '~/pages/car/account/eshop/transactions.vue' /* webpackChunkName: "pages-account-eshop-transactions.vue" */
            )
          ),
        meta: {
          scrollTopSmooth: true
        }
      },
      {
        path: 'reviews/',
        name: '__account_eshop_reviews',
        component: () =>
          interopDefault(
            import(
              '~/pages/car/account/eshop/reviews/list.vue' /* webpackChunkName: "pages-account-eshop-reviews-list.vue" */
            )
          ),
        meta: {
          scrollTopSmooth: true
        }
      },
      {
        path: 'return-policy/',
        name: '__account_eshop_return_policy',
        component: () =>
          interopDefault(
            import(
              '~/pages/car/account/eshop/return-policy.vue' /* webpackChunkName: "pages-account-eshop-return-policy.vue" */
            )
          ),
        meta: {
          scrollTopSmooth: true
        }
      },
      {
        path: 'settings/',
        name: '__account_eshop_settings',
        component: () =>
          interopDefault(
            import(
              '~/pages/car/account/eshop/settings.vue' /* webpackChunkName: "pages-account-eshop-settings.vue" */
            )
          ),
        meta: {
          scrollTopSmooth: true
        }
      }
    ]
  }
]
